import { i as v, A as P } from "./abort.js";
import { c as T } from "./requesterEntity.js";
import { d as l } from "./requesterUpload.js";
import { g as F, b as L, f as b, A as S, d as U, F as k } from "./requestHelpers.js";
import { r as B } from "./retry.js";
function z() {
  return D();
}
function D() {
  const a = new EventTarget();
  return {
    ...y({ onApiError: i }),
    onUnauthorized: p,
    onApiError: u,
    dispatchApiError: i
    // webdav dispatch error here when throw api errors
  };
  function i(o) {
    a.dispatchEvent(new CustomEvent("error", { detail: o }));
  }
  function u(o) {
    const n = (d) => o(d.detail);
    return a.addEventListener("error", n), () => a.removeEventListener("error", n);
  }
  function p(o) {
    return u((n) => n.response.status === 401 && o());
  }
}
function y(a) {
  const m = { get: d, post: w, del: f, patch: R, put: A, request: n, entity: u, fork: i };
  return m;
  function i() {
    return y(a);
  }
  function u(e) {
    return T({ endpoint: e, requester: m });
  }
  async function p(e, r) {
    try {
      return await fetch(e, r);
    } catch (t) {
      const s = t instanceof Error ? t.message : "Fetch error";
      throw v(t) ? new P(s) : k.fromFetch(e, r, t);
    }
  }
  function o(e, r, t) {
    return e ? l(r, { ...t, onProgress: e }) : p(r, t);
  }
  async function n(e, r) {
    const t = F(r), s = `${e}${L(r == null ? void 0 : r.query)}`, h = b(r);
    let c;
    if (h ? c = await B(
      () => o(r == null ? void 0 : r.onProgress, s, t),
      h
    ) : c = await o(r == null ? void 0 : r.onProgress, s, t), !c.ok) {
      const E = await S.fromResponse(c, t == null ? void 0 : t.method);
      throw a.onApiError(E), E;
    }
    return r != null && r.response ? c : await U(c);
  }
  async function d(e, r, t) {
    return n(e, { ...t, query: r, method: "GET" });
  }
  async function w(e, r, t, s) {
    return n(e, { ...s, body: r, query: t, method: "POST" });
  }
  async function A(e, r, t) {
    return n(e, { body: r, query: t, method: "PUT" });
  }
  async function R(e, r, t) {
    return n(e, { body: r, query: t, method: "PATCH" });
  }
  async function f(e, r) {
    return n(e, { query: r, method: "DELETE" });
  }
}
export {
  y as a,
  D as c,
  z as u
};
//# sourceMappingURL=requester.js.map
